module.exports = __webpack_public_path__ + "a920876dbc1a1222b1e0e2b5777f4f0c.woff2";